import axios from "axios";

const platformApi = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/platform`,
  withCredentials: true, // send the httpOnly platform refresh cookie
});

platformApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("aetria_platform_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

let isRefreshing = false;
let waiters = [];
const skipRefresh = (url = "") =>
  url.includes("/auth/refresh") || url.includes("/auth/login") || url.includes("/auth/logout");

platformApi.interceptors.response.use(
  (res) => res,
  async (err) => {
    const original = err.config || {};
    const status = err.response?.status;
    if (status === 401 && !original._retry && !skipRefresh(original.url)
        && window.location.pathname.startsWith("/platform")) {
      if (isRefreshing) {
        return new Promise((resolve, reject) => waiters.push({ resolve, reject }))
          .then(() => platformApi(original));
      }
      original._retry = true;
      isRefreshing = true;
      try {
        const { data } = await platformApi.post("/auth/refresh");
        localStorage.setItem("aetria_platform_token", data.access_token);
        waiters.forEach((w) => w.resolve());
        waiters = [];
        return platformApi(original);
      } catch (refreshErr) {
        waiters.forEach((w) => w.reject(refreshErr));
        waiters = [];
        localStorage.removeItem("aetria_platform_token");
        return Promise.reject(refreshErr);
      } finally {
        isRefreshing = false;
      }
    }
    if (status === 401 && window.location.pathname.startsWith("/platform")) {
      localStorage.removeItem("aetria_platform_token");
    }
    return Promise.reject(err);
  }
);

export default platformApi;
